module.exports = __webpack_public_path__ + "img/UIC.0b2bae3d.jpeg";